import {Link} from "react-router-dom";
import Slider from "react-slick";
import styled, {keyframes} from "styled-components";
import img1 from "../assets/slide2.jpg";
import img2 from "../assets/slide11.png";
import img3 from "../assets/slide4.jpg";

const settings = {
    fade: true,
    infinite: true,
    speed: 1700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: false,
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const Image = styled.img`
    width: 100%;
    height: 130vh;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;

    @media (max-width: 768px) {
        height: 90vh;
    }
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 130vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;

    @media (max-width: 768px) {
        height: 90vh;
    }
`;

const BannerDiv = styled.div`
    height: 130vh;
    position: relative;

    @media (max-width: 768px) {
        height: 90vh;

        &:hover {
            transform: none;
        }
    }
`;

const Slide = styled.div`
    width: 100%;
    height: 130vh;

    @media (max-width: 768px) {
        height: 90vh;
    }
`;

const TextContainer = styled.div`
    position: absolute;
    top: 18%;
    right: 15%;
    z-index: 2;
    background: rgba(0, 0, 0, 0.4);
    padding: 20px 70px;
    margin: 0 50px;
    border-radius: 15px;
    box-shadow: 6px 3px 14px 3px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
        top: 27%;
    }

    @media (max-width: 955px) {
        padding: 40px 20px;
        margin: 0 10px;
        right: 10px;
    }
`;

const GradientText = styled.h1`
    font-size: 5rem;
    line-height: 1;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    text-transform: uppercase;
    color: yellowgreen;
    animation: ${gradientShift} 6s ease infinite, ${fadeIn} 1.5s ease-out;

    @media (max-width: 768px) {
        font-size: 2rem;
        line-height: 1.2;
    }
`;

const SubText = styled.p`
    font-size: 1.6rem;
    margin: 1rem 0;
    line-height: 1;
    color: rgba(255, 255, 255, 0.8);

    animation: ${fadeIn} 1.5s ease-out;

    @media (max-width: 768px) {
        font-size: 0.9rem;
        line-height: 1.2;
    }
`;

const CallToAction = styled(Link)`
    display: inline-block;
    padding: 1rem 1.8rem;
    font-size: 1.5rem;
    font-weight: bold;
    width: max-content;
    text-transform: uppercase;
    color: #fff;
    background: #f03e3e;

    background-size: 300% 300%;
    text-decoration: none;
    border-radius: 5px;
    box-shadow: 0px 4px 15px #f03c6e;
    transition: all 0.3s ease-in-out;
    animation: ${fadeIn} 2s ease-out;

    &:hover {
        background-position: 100% 0;
        background: transparent;
        box-shadow: 0px 6px 20px rgba(255, 126, 95, 0.7);
        transform: translateY(-5px);
    }

    &:active {
        transform: translateY(1px);
        box-shadow: 0px 2px 10px rgba(255, 126, 95, 0.3);
    }

    @media (max-width: 768px) {
        width: 100%;
        font-size: 1.1rem;
        padding: 0.6rem 1.5rem;
    }
`;

const textContent = [
    {
        heading: "Unleashing atmospheric Sounds that move the soul",
        subtext: "Discover, develop, and dominate the airwaves.",
        LinkText: "Submit Your Demo",
        link: "/xtiim-artists/registration",
        image: img1,
    },
    {
        heading: "Fueling the Future of Music",
        subtext: "Your sound. Our platform. The world is listening.",
        LinkText: "Meet Our Artists",
        link: "/Artists",
        image: img2,
    },
    {
        heading: "Where Raw Talent Meets the Spotlight",
        subtext: "Bringing underground sounds to global stages.",
        LinkText: "Join the Movement",
        link: "/xtiim-artists/registration",
        image: img3,
    },
];

const Banner = () => {
    return (
        <BannerDiv className="slider-container">
            <Slider {...settings}>
                {textContent.map((item, index) => (
                    <Slide key={index}>
                        <Image src={item.image} alt={`Slide ${index + 1}`} />
                        <Overlay />
                        <TextContainer>
                            <GradientText>{item.heading}</GradientText>
                            <SubText>{item.subtext}</SubText>
                            <CallToAction to={item.link}>{item.LinkText}</CallToAction>
                        </TextContainer>
                    </Slide>
                ))}
            </Slider>
        </BannerDiv>
    );
};

export default Banner;
